/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import endImage from '../../assets/end-image.svg'

import usePersistedState from '../../hooks/usePersistedState'

import Button from '../../components/Button'
import Header from '../../components/Header'

import { UserData } from '../../utils/interfaces'

const End: React.FC = () => {
  const [userData] = usePersistedState<UserData>('userData', {} as UserData)

  const navigate = useNavigate()

  const handleNewParticipant = useCallback(() => {
    navigate('/register')

    localStorage.removeItem('@Iprejun:documentsAttached')
    localStorage.removeItem('@Iprejun:erroProps')
    localStorage.removeItem('@Iprejun:participantsGroup')
    localStorage.removeItem('@Iprejun:servicestimeGroup')
    localStorage.removeItem('@Iprejun:tipoContato')
    localStorage.removeItem('@Iprejun:userData')
  }, [navigate])

  return (
    <>
      <Header />
      <div className="mx-auto my-[35px] flex max-w-[600px] flex-col items-center px-[5px] max-[766px]:max-w-[500px]">
        <main className="flex w-full flex-col items-center rounded-[8px] bg-white p-[30px_25px] shadow-[0px_2px_4px_rgba(0,0,0,0.05),0px_6px_12px_rgba(61,69,67,0.05)] mx-[5px]">
          <strong className="mb-[12px] text-center text-[16px] text-[#0071ba]">
            Pronto! Seu cadastro no IPREJUN foi enviado com sucesso.
          </strong>
          <img
            src={endImage}
            alt="Finalizar"
            className="my-[30px] h-[185px] w-auto"
          />

          <p className="w-[80%] pb-[20px] text-center text-[14px] leading-[18px]">
            Agora nossos especialistas irão conferir todos os detalhes para a
            conclusão do cadastro e disponibilização do protocolo, em até 03
            dias úteis.
          </p>

          <div className="flex flex-col items-center">
            <strong>ACESSE O NOSSO SITE:</strong>
            <a
              href="https://iprejun.sp.gov.br/N/"
              target="_blank"
              className="relative flex items-center text-[#333] no-underline hover:underline focus:underline"
            >
              iprejun.sp.gov.br
            </a>
          </div>
        </main>
      </div>
    </>
  )
}

export default End
